/**
 * @fileoverview Section "Radius" — coins arrondis GNPC (base 8 px).
 */

import { CopyButton } from '@gnpc/ui';
import { DsPreview } from '../components/DsPreview.tsx';

const RADII = [
  { class: 'rounded-none', label: 'rounded-none', size: '0', usage: 'Tables, séparateurs' },
  { class: 'rounded-sm', label: 'rounded-sm', size: '4 px', usage: 'Petits badges, code inline' },
  { class: 'rounded-md', label: 'rounded-md', size: '6 px', usage: 'Boutons, inputs' },
  { class: 'rounded-lg', label: 'rounded-lg', size: '8 px', usage: 'Cards, dialogs' },
  { class: 'rounded-xl', label: 'rounded-xl', size: '12 px', usage: 'Modals accueil, panels' },
  { class: 'rounded-full', label: 'rounded-full', size: '9999 px', usage: 'Avatars, pills' },
] as const;

export function DsSectionRadius(): JSX.Element {
  return (
    <div className="space-y-3">
      <p className="text-xs text-muted-foreground">
        Base 8 px pour <code>rounded-lg</code>. Composants standards (Button, Input,
        Card interne) utilisent <code>rounded-md</code>. Cards conteneur passent à{' '}
        <code>rounded-lg</code>. Pas de radius asymétrique dans le DS.
      </p>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {RADII.map((r) => (
          <DsPreview key={r.class} label={`${r.label} · ${r.size}`} align="center">
            <div className="flex items-center gap-3">
              <div
                className={`size-14 border-2 border-quipux-orange-500 bg-quipux-orange-500/10 ${r.class}`}
              />
              <div className="text-xs">
                <p className="font-medium text-quipux-navy-900">{r.usage}</p>
                <div className="mt-1 flex items-center gap-1">
                  <code className="font-mono text-[10px] text-muted-foreground">
                    {r.label}
                  </code>
                  <CopyButton value={r.class} ariaLabel={`Copier ${r.class}`} />
                </div>
              </div>
            </div>
          </DsPreview>
        ))}
      </div>
    </div>
  );
}
